import { FC } from 'react';

import { StyledSortTabs, TabsWrapper } from './TabsFilterStyle';

export interface TabsFilterProps {
  data: Array<any>;
  activeKey: string;
  handleTabClick: (
    key: string,
    e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>
  ) => void;
}

const TabsFilter: FC<TabsFilterProps> = ({
  data,
  activeKey,
  handleTabClick,
}) => {
  return (
    <TabsWrapper>
      <StyledSortTabs activeKey={activeKey} onTabClick={handleTabClick}>
        {data.map((tab) => {
          return (
            <StyledSortTabs.TabPane
              disabled={tab.disabled}
              tab={tab.label}
              key={tab.id}
            />
          );
        })}
      </StyledSortTabs>
    </TabsWrapper>
  );
};

export default TabsFilter;
